import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { IRegionCity } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-by-region';
import { IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';

import { setRegions } from '../actionCreators';

const updateRegions = (region: IRegionWithCities, cities: IRegionCity[]) => {
    return (dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState): void => {
        const { citySelect: { regions } } = getState();
        const regionLetter = region.name.charAt(0);
        const letterRegions = [...regions[regionLetter]];

        const updatedRegionIndex = letterRegions.findIndex(_region => _region.region_id === region.region_id);

        if (updatedRegionIndex !== -1) {
            const regionWithCities: IRegionWithCities = { ...letterRegions[updatedRegionIndex], cities };
            letterRegions.splice(updatedRegionIndex, 1, regionWithCities);
            dispatch(setRegions({
                ...regions,
                [regionLetter]: letterRegions,
            }));
        }
    };
};

export default updateRegions;
